import { wrapperBuilder } from './build';
import { getCoreFetch } from './functions';

wrapperBuilder
  .getStaticsGeneratorsRegisterInstance()
  .addStaticProp('getCoreFetch', getCoreFetch);
